var scope_0 = require('/opt/build/repo/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/12ca2c5441c392029c91433b207bf0a0.js').default;
var scope_1 = require('/opt/build/repo/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/70d0573f420338f448e3f51cc97aae65.js').default;
var scope_2 = require('/opt/build/repo/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/87ae7127d78efd54bf02a12b42f0c954.js').default;
var scope_3 = require('/opt/build/repo/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bb371b604cd58d6bdc41f05f30d23fb7.js').default;
var scope_4 = require('/opt/build/repo/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/db92d965fb7d983141a8d6016e4d4ae8.js').default;
var scope_5 = require('/opt/build/repo/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e179106b72b451bd33ecab5e90d0ed2c.js').default;
var scope_6 = require('/opt/build/repo/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6 )
    